<template>
  <div id="app">
    <TitlePage v-bind:clientName="clientName" />
    <Audit v-if="AuditChecked" />
    <!-- <Audit v-if="$dynamic('clientName', []).includes('clientName')" /> -->
    <Seo v-if="SeoChecked" />
    <Ppc v-if="PpcChecked" />
    <!-- <Pcc /> -->
    <Pricing />
    <PricingTable />
    <Trader v-bind:traderName="selectedTrader" />
  </div>
</template>

<script>
console.log('test1')
// console.log(clientName)
console.log('test2')
import TitlePage from '@/components/TitlePage.vue'
import Audit from '@/components/Audit.vue'
import Seo from '@/components/Seo.vue'
import Ppc from '@/components/Ppc.vue'
import Pricing from '@/components/Pricing.vue'
import PricingTable from '@/components/PricingTable.vue'
import Trader from '@/components/Trader.vue'
// import Navbar from '@/components/NavBar.vue'
// import Page4 from '@/components/Page4.vue'

export default {
  name: 'Preview',
  components: {
    TitlePage,
    Audit,
    Seo,
    Ppc,
    Trader,
    Pricing,
    PricingTable,
  },
  props: {
    clientName: {
      type: String,
      required: true,
    },
    AuditChecked: {
      type: Boolean,
    },
    SeoChecked: {
      type: Boolean,
    },
    PpcChecked: {
      type: Boolean,
    },
    selectedTrader: {
      type: String,
    },
  },
}
</script>

<style>
h1,
h2,
h3 {
  font-family: 'Raleway', sans-serif;
  font-weight: 800;
  text-transform: uppercase;
}

h1 {
  font-size: 42px;
  margin: 0;
  padding: 0;
}
h2 {
  margin: 0;
  padding: 0;
  font-size: 72px;
}

body {
  font-family: 'Open Sans', sans-serif;
  margin: 0;
}

.container {
  margin: 70px;
}

#app {
  font-family: 'Open Sans', sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
  margin: 0;
  padding: 0;
}

.page {
  position: relative;
  overflow: hidden;
  padding: 0.8in;
  page-break-after: always;
}

.page.landscape {
  width: 11.7in;
  height: 7.795in;
}

.background {
  position: absolute;
  min-width: 100%;
  min-height: 100%;
  background: #000;
  opacity: 0.4;
  z-index: -1;
}

.flex {
  display: flex;
  align-items: space-around;
  justify-content: center;
  flex-direction: row;
}

.bg-image {
  background: #000;
  background-size: cover;
  width: 400px;
  height: 10vh;
  padding: 0;
  margin-top: -105px;
  margin-right: -80px;
  object-fit: cover;
}
.overlay {
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  display: none;
  background-color: rgba(0, 0, 0, 0.5);
}
.bg-image img {
  object-fit: cover;
}

.bolder {
  font-weight: 600;
}
</style>
